export const readableTime = (seconds: number) => {
  const totalHours = Math.floor(seconds / 360) / 10;
  const weeks = Math.floor(seconds / 144000); // 5d * 8h * 3600s = 144000s per week
  const days = Math.floor((seconds % 144000) / 28800); // 8h * 3600s = 28800s per day
  const hours = Math.floor((seconds % 28800) / 3600); // 3600s per hour
  const minutes = Math.floor((seconds % 3600) / 60); // 60s per minute

  const res =
    (weeks ? `${weeks}w ` : '') +
    (days ? `${days}d ` : '') +
    (hours ? `${hours}h ` : '') +
    (minutes ? `${minutes}m ` : '') +
    (days + weeks > 0 ? `(${totalHours})` : '');

  if (weeks + days + hours + minutes === 0) return '0m';
  if (res.at(-1) === ' ') return res.slice(0, -1);
  return res;
};
